/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import Buttons from "../../components/Buttons/Buttons";
import Stepper, { totalSteps } from "../../components/Stepper/Stepper";
import BasicDetails from "./BasicDetails";
import { FormikProps } from "formik";
import { useSelector,useDispatch } from "react-redux";
import { RootState } from "../../redux/Reducer";

import {
  CREATE_NEGOTIATION,
  GET_POWER_POSITION_SUCCESS,
  GET_SELECTED_ACTION_TILES_SUCCESS,
  GET_TARGET_VALUE_DETAILS_SUCCESS,
  POST_SAVE_FORM_DETAILS,
  RESET_BASIC_DETAILS,
  RESET_SELECTED_ACTION_TILES,
  RESET_POWER_POSITION,
  RESET_SALES_REP_CLASSIFICATION,
  RESET_TARGET_VALUE_DETAILS,
  GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS,
  GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS,
  GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS,
} from "../../redux/Action/actionTypes";
import SalesRepClassification from "./Sales Rep Classification/salesRepClassification";
import TargetValue from "./TargetValue";
import { Spinner } from "reactstrap";
import ToastNotifier from "../../components/ToastNotifier/toastNotifier";
import PowerPositionComponent from "./Power Position/powerPosition";
import PlanNegotiationActions from "./PlanNegotiationActions/PlanNegotiationActions";
import { useNavigate } from "react-router-dom";

interface MyFormValues {
  negotiationName: string;
  leadCountry: string;
  categoryName: string;
  categoryCode: string;
  cluster: string;
  negotiationTeam: string;
  od: string;
  suppliers: string;
  supplierLocation: string;
  salesRepLead: string;
  additionalSalesRep: string;
  negotiationDateMonth: string;
  negotiationDateYear: string;
  negotiationImplementationMonth: string;
  negotiationImplementationYear: string;
  validityPeriod: number;
  relevantSpend: number;
  comment: string;
}

interface LocalFields {
  supplierExistOrNot: string;
  supplierAwareness: string;
  supplierDependent: string;
}
const NegotiationStepperForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [innerStep, setInnerStep] = useState(0);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const basicDetailsData = useSelector(
    (state: RootState) => state.basicDetails.basicDetailsData
  );
  const powerPositionDetails = useSelector(
    (state: RootState) => state.powerPosition
  );
  const TargetValueData = useSelector(
    (state: RootState) => state.TargetValue.TargetValueData
  );
  const salesRepClassificationData = useSelector(
    (state: RootState) => state.salesRepClassification
  );
  const isLoader = useSelector(
    (state: RootState) => state.toastMessageReducer.loading
  );
  const [selectedActionTilesMap, setSelectedActionTilesMap] = useState<any>([]);
  const selectedPlanActionCards: any = useSelector(
    (state: RootState) => state.selectedActionTiles.SelectedActionTilesData
  );
  useEffect(() => {
    if (
      selectedPlanActionCards &&
      Object.keys(selectedPlanActionCards).length > 0
    ) {
      setSelectedActionTilesMap(selectedPlanActionCards);
    }
  }, [selectedPlanActionCards]);

  const navigate = useNavigate();
  const isFormUpdate = useSelector(
    (state: RootState) => state.basicDetails.formState
  );

  // ref variable for continue (submit btn) button
  const formikRef = useRef<FormikProps<any>>(null);
  const dispatch = useDispatch();

  const totalRounds = TargetValueData.rounds;
  const totalInnerSteps = Number(totalRounds) + 2;

  const handleActionTilesUpdate = (roundName: string, selectedCards: any[]) => {
    const updatedMap = {
      ...selectedActionTilesMap,
      [roundName]: selectedCards,
    };
    setSelectedActionTilesMap(updatedMap);

    // Optional: Sync to Redux immediately
    dispatch({
      type: GET_SELECTED_ACTION_TILES_SUCCESS,
      payload: updatedMap,
    });
  };

  const goNext = () => {
    if (!isNextDisabled || currentStep === 2 || currentStep === 1) {
      if (currentStep < totalSteps - 1) {
        setCurrentStep((prev) => prev + 1);
      }
    }
    // form submission for each steps
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
    if (currentStep === 3) {
      dispatch({
        type: GET_TARGET_VALUE_DETAILS_SUCCESS,
        payload: formikRef.current?.values,
      });
    }
    if (currentStep === 4) {
      dispatchSelectedActions(innerStep);
      if (innerStep < totalInnerSteps - 1) {
        setInnerStep((prev) => prev + 1);
      }
    }
    if (currentStep === 4 && innerStep === totalInnerSteps - 1) {
      const simplified: Record<
        string,
        { ID: string; ImplementationApproach: string }[]
      > = {};
      const allKeys = ["Preparation"];
      for (let i = 1; i < totalInnerSteps - 1; i++) {
        allKeys.push("Round" + i);
      }
      allKeys.push("Finalization");
      allKeys.forEach((key) => {
        const items = selectedActionTilesMap[key];
        if (Array.isArray(items)) {
          simplified[key] = items.map((item: any) => ({
            ID: item.id,
            ImplementationApproach: item.inputText,
          }));
        } else {
          simplified[key] = []; // Ensure empty arrays for missing steps
        }
      });
      dispatch({
        type: POST_SAVE_FORM_DETAILS,
        payload: {
          isFormUpdate,
          basicDetailsData,
          salesRepClassificationData,
          powerPositionDetails,
          TargetValueData,
          PlanNegotiationActions: simplified,
          IsSavedForLater: false,
        },
        meta: {
          onSuccess: () => {
            navigate("/");
            dispatch({ type: RESET_BASIC_DETAILS });
            dispatch({ type: RESET_POWER_POSITION });
            dispatch({ type: RESET_SALES_REP_CLASSIFICATION });
            dispatch({ type: CREATE_NEGOTIATION });
            dispatch({ type: RESET_TARGET_VALUE_DETAILS });
            dispatch({ type: RESET_SELECTED_ACTION_TILES });
          },
        },
      });
    }
  };

  const goBack = () => {
    if (currentStep === 4 && innerStep > 0) {
      setInnerStep((prev) => prev - 1);
    }
    if (currentStep > 0 && innerStep === 0) {
      if (currentStep === 1 || currentStep === 2) {
        dispatch({ type: GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS, payload: {} })
      }
      if (currentStep === 2 || currentStep === 3) {
        dispatch({ type: GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS, payload: {} })
      }
      if(currentStep === 4){
         dispatch({ type: GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS, payload: {} })
      }
      setCurrentStep((prev) => prev - 1);
    }
  };
  const goToStep = (targetStep: number) => {
    const isGoingForward = targetStep > currentStep;
    if (!isGoingForward || (isGoingForward && !isNextDisabled)) {
      setCurrentStep(targetStep);
      if (formikRef.current) {
        formikRef.current.submitForm();
      }
      if (targetStep === 4) {
        dispatchSelectedActions(innerStep);
      }
      if (currentStep === 3) {
        dispatch({
          type: GET_TARGET_VALUE_DETAILS_SUCCESS,
          payload: formikRef.current?.values,
        });
      }
      if(currentStep==4){
         dispatch({ type: GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS, payload: {} })
      }
      if(currentStep==1){
         dispatch({ type: GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS, payload: {} })
      }
      if(currentStep==2){
         dispatch({ type: GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS, payload: {} })
      }
    }
  };
  const dataCheckHandler = (selectedArr: any[], existingArr: any[]) => {
    let FinalArr = [...existingArr];
    selectedArr?.map((selectedData: any) => {
      let isDataExist = false;
      existingArr.forEach((existingData: any) => {
        if (existingData.id === selectedData.id) {
          isDataExist = true;
        }
      });
      if (!isDataExist) {
        FinalArr.push(selectedData);
      }
    });
    return FinalArr;
  };

  const dispatchSelectedActions = (stepIndex: number) => {
    let dispatchPayload: any = { ...selectedPlanActionCards };
    if (stepIndex === 0) {
      dispatchPayload["Preparation"] = dataCheckHandler(
        selectedActionTilesMap.Preparation || [],
        dispatchPayload.Preparation || []
      );
    } else if (stepIndex < totalInnerSteps - 1) {
      const RoundName = "Round" + stepIndex;
      dispatchPayload[RoundName] = dataCheckHandler(
        selectedActionTilesMap[RoundName] || [],
        dispatchPayload[RoundName] || []
      );
    }
    const isFinalizationStep = stepIndex === totalInnerSteps - 1;
    if (isFinalizationStep) {
      dispatchPayload["Finalization"] = dataCheckHandler(
        selectedActionTilesMap.Finalization || [],
        dispatchPayload.Finalization || []
      );
    }
    dispatch({
      type: GET_SELECTED_ACTION_TILES_SUCCESS,
      payload: dispatchPayload,
    });
  };

  const saveHandler = () => {
    if (currentStep === 0) {
      dispatch({
        type: POST_SAVE_FORM_DETAILS,
        payload: {
          basicDetailsData: formikRef.current?.values,
          powerPositionDetails,
          salesRepClassificationData,
          TargetValueData,
          isFormUpdate,
        },
      });
    } else if (currentStep === 1) {
      dispatch({
        type: GET_POWER_POSITION_SUCCESS,
        payload: formikRef.current?.values,
      });
      dispatch({
        type: POST_SAVE_FORM_DETAILS,
        payload: {
          isFormUpdate,
          basicDetailsData,
          salesRepClassificationData,
          TargetValueData,
          powerPositionDetails: {
            powerPositionData: formikRef.current?.values,
          },
        },
      });
    } else if (currentStep === 3) {
      dispatch({
        type: GET_TARGET_VALUE_DETAILS_SUCCESS,
        payload: formikRef.current?.values,
      });
      dispatch({
        type: POST_SAVE_FORM_DETAILS,
        payload: {
          isFormUpdate,
          basicDetailsData,
          salesRepClassificationData,
          powerPositionDetails,
          TargetValueData: formikRef.current?.values,
        },
      });
    } else if (currentStep === 4) {
      const simplified: Record<
        string,
        { ID: string; ImplementationApproach: string }[]
      > = {};
      const allKeys = ["Preparation"];
      for (let i = 1; i < totalInnerSteps - 1; i++) {
        allKeys.push("Round" + i);
      }
      allKeys.push("Finalization");
      allKeys.forEach((key) => {
        const items = selectedActionTilesMap[key];
        if (Array.isArray(items)) {
          simplified[key] = items.map((item: any) => ({
            ID: item.id,
            ImplementationApproach: item.inputText,
          }));
        } else {
          simplified[key] = []; // Ensure empty arrays for missing steps
        }
      });
      dispatch({
        type: POST_SAVE_FORM_DETAILS,
        payload: {
          isFormUpdate,
          basicDetailsData,
          salesRepClassificationData,
          powerPositionDetails,
          TargetValueData,
          PlanNegotiationActions: simplified,
        },
      });
    } else {
      dispatch({
        type: POST_SAVE_FORM_DETAILS,
        payload: {
          isFormUpdate,
          basicDetailsData,
          salesRepClassificationData,
          powerPositionDetails,
          TargetValueData,
        },
      });
    }
  };

  return (
    <div className="NegotiationStepperForm">
      <Stepper
        currentStep={currentStep}
        goToStep={goToStep}
        isNextDisabled={isNextDisabled}
      />
      {currentStep === 0 && (
        <BasicDetails
          setIsNextDisabled={setIsNextDisabled}
          setRefInstance={(instance: FormikProps<any> | null) =>
            (formikRef.current = instance)
          }
        />
      )}
      {currentStep === 1 && (
        <PowerPositionComponent
          currentStep={currentStep}
          totalSteps={totalSteps}
          goNext={goNext}
          goBack={goBack}
          isNextDisabled={isNextDisabled}
        />
      )}
      {currentStep === 2 && (
        <SalesRepClassification
          currentStep={currentStep}
          totalSteps={totalSteps}
          goNext={goNext}
          goBack={goBack}
          isNextDisabled={isNextDisabled}
        />
      )}
      {currentStep === 3 && (
        <TargetValue
          setIsNextDisabled={setIsNextDisabled}
          setRefInstance={(instance: FormikProps<any> | null) =>
            (formikRef.current = instance)
          }
        />
      )}
      {currentStep === 4 && (
        <PlanNegotiationActions
          currentStep={innerStep}
          totalSteps={totalInnerSteps}
          goToStep={(index: any) => {
            dispatchSelectedActions(innerStep);
            setInnerStep(index);
          }}
          onCardSelect={handleActionTilesUpdate}
        ></PlanNegotiationActions>
      )}

      {![1, 2].includes(currentStep) && (
        <Buttons
          isLastStep={
            innerStep === totalInnerSteps - 1 && currentStep === 4
          }
          currentStep={currentStep}
          totalSteps={totalSteps}
          goNext={goNext}
          goBack={goBack}
          isNextDisabled={isNextDisabled}
          saveHandler={saveHandler}
        />
      )}
      <ToastNotifier />
      {isLoader && (
        <div className="spinner-overlay">
          <Spinner className="spinner-style"></Spinner>
        </div>
      )}
    </div>
  );
};

export default NegotiationStepperForm;
